import React, { useEffect, useState } from 'react'
import ReactTable from 'react-table';
import { Button, Col, Input, Label, Row } from 'reactstrap'
import { connect } from "react-redux";
import GetStoresDataToAssociateWithAccountService from '../../../../../../../Service/OPSServices/AccountDetailsService/GetStoresDataToAssociateWithAccountService';
import AssociateStoreAndUserToAccountService from '../../../../../../../Service/OPSServices/AccountDetailsService/AssociateStoreAndUserToAccountService';
import CustomModal from '../../../../../../Components/Modals/CustomModal';


function AssociateStoresToAccountDetails(props) {
    const [associateStoreAndUserList, setAssociateStoreAndUserList] = useState([]);
    const [associateStoreAndUserToAccount, setAssociateStoreAndUserToAccount] = useState([]);
    const [integerIDList,setIntegerIDList]= useState([]);
    const [priorityAccounts, setPriorityAccounts] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [accountList,setAccountList]= useState([]);
    const [openAssociateStoresConfirmationPopup,setOpenAssociateStoresConfirmationPopup]=useState(false);
    useEffect(() => {
      GetStoresDataToAssociateWithAccountService(props.token).then((response) => {
        if (response) {
          const updatedResponse = response.map(store => ({
            ...store,
            alreadyAssociated: store.AccountDetails_id === props.AccountDetailsId
          }));
          setAssociateStoreAndUserList(updatedResponse);
        }
      });
    }, []);
    
      const selectedStoreList = (storeId, accountName) => {
        const relatedStoreIds = associateStoreAndUserList
          .filter((row) => row.AccountDetails_name === accountName)
          .map((row) => row.integerID);
        const allAlreadySelected = relatedStoreIds.every((id) => integerIDList.includes(id));
      
        setIntegerIDList((prev) => {
          if (allAlreadySelected) {
            return prev.filter((id) => !relatedStoreIds.includes(id));
          } else {
            return [...new Set([...prev, ...relatedStoreIds])];
          }
        });
        setPriorityAccounts((prev) => {
          const alreadyExists = prev.includes(accountName);
          if (allAlreadySelected && alreadyExists) {
            return prev.filter((acc) => acc !== accountName);
          } else if (!alreadyExists) {
            return [...prev, accountName];
          }
          return prev;
        });
      };

      const filterStoreData = associateStoreAndUserList
      .filter((row) => {
        const accountName = (row.AccountDetails_name || '').toLowerCase();
        const storeName = (row.storeName || '').toLowerCase();
        const userName = (row.userName || '').toLowerCase();
        return (
          accountName.includes(searchText.toLowerCase()) ||
          storeName.includes(searchText.toLowerCase()) ||
          userName.includes(searchText.toLowerCase())
        );
      })
      .sort((a, b) => {
        // First: alreadyAssociated stores come first
        if (a.alreadyAssociated && !b.alreadyAssociated) return -1;
        if (!a.alreadyAssociated && b.alreadyAssociated) return 1;
    
        // Second: sort by priorityAccounts (if manually selected)
        const aIndex = priorityAccounts.indexOf(a.AccountDetails_name);
        const bIndex = priorityAccounts.indexOf(b.AccountDetails_name);
    
        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
    
        return aIndex - bIndex;
      });
    

  const handleStoreWiseProducts = () => {
    // ;
    setOpenAssociateStoresConfirmationPopup(true);
  };


    const handleConfirmAssociation = () => {
      const data = {
        IntegerID: integerIDList,
        AccountID: props.AccountDetailsId
      };
    
      AssociateStoreAndUserToAccountService(props.token, data).then((response) => {
        if (response) {
          console.log(response);
          props.setTeamMembers(response.simpliusers)
          props.setStoreList(response.store_List);
        }
        if (response.store_List && Array.isArray(response.store_List) && response.store_List.length > 0) {
          props.setStoreUserListData(response.store_List[0].userList || '');
          props.setSelectedStoreBg(response.store_List[0].integerID || '');
      } else {
        props.setStoreUserListData('');
        props.setSelectedStoreBg('');
      }
        setOpenAssociateStoresConfirmationPopup(false);
        props.setAssociateStoresPopup(false)
      });
    };
    
    const Column = [
      {
        Header: "Associate",
        accessor: "integerID",
        width: 80,
        Cell: (cellInfo) => {
          const isDisabled = cellInfo.original.alreadyAssociated;
          return (
            <div className="d-flex justify-content-center w-100">
              <input
                type="checkbox"
                checked={integerIDList.includes(cellInfo.value) || isDisabled}
                disabled={isDisabled}
                onChange={() => {
                  if (!isDisabled) {
                    selectedStoreList(cellInfo.value, cellInfo.original.AccountDetails_name);
                  }
                }}
              />
            </div>
          );
        },
      },
      
      
      
        {
          Header: 'Account Name',
          accessor: 'AccountDetails_name',
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-start w-100">
              <p className="mb-0 comment-paragraph">{cellInfo.value}</p>
            </div>
          ),
        },
        {
          Header: 'Store Name',
          accessor: 'storeName',
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-start w-100">
                <p className="mb-0 comment-paragraph">{cellInfo.value}</p>
              {/* <p onClick={() => handleAccountDetails(cellInfo.original)}
              title={cellInfo.value}
                className="mb-0 cursor-pointer comment-paragraph">{cellInfo.value}</p> */}
            </div>
          ),
        },
        {
          Header: 'Current Owner Name',
          accessor: 'userName',
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-start w-100">
              <p title={cellInfo.value} className="mb-0 comment-paragraph">{cellInfo.value}</p>
            </div>
          ),
        },
       
      ];
    


  return (

    <>
    <Row>
    <Col md={12}>
             <div className='d-flex justify-content-end'>
                <Input
                  className="mb-2 w-50"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search Store by Account Name or Owner"
                />
                </div>
              </Col>
    <Col md={12}>
          {/* <ReactTable
            data={filterStoreData}
            columns={Column}
            className="-fixed -highlight -striped"
            getTheadProps={() => {
              return {
                style: {
                  overflowY: "hidden",
                  background: "#B1FA63",
                  // color: "#243837",
                },
              };
            }}
            defaultPageSize={10}
            noDataText="Loading Stores List..."
          /> */}
          <ReactTable
              data={filterStoreData}
              columns={Column}
              className="-fixed -highlight -striped"
              getTrProps={(state, rowInfo) => {
                const isDisabled = rowInfo && rowInfo.original && rowInfo.original.alreadyAssociated;
                return {
                  style: {
                    background: isDisabled ? '#f0f0f0' : 'white',
                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                  }
                };
              }}
              getTheadProps={() => ({
                style: {
                  overflowY: "hidden",
                  background: "#B1FA63",
                }
              })}
              defaultPageSize={10}
              noDataText="Loading Stores List..."
            />

        </Col>
        <Col className="d-flex justify-content-center mt-2">
              <Button
                className="btn-background-color"
                disabled={integerIDList && integerIDList.length> 0 ? false : true}
                onClick={() => handleStoreWiseProducts()}
                >
                Done
              </Button>
            </Col>
    </Row>
    <CustomModal
  header={'Confirmation Popup'}
  isOpen={openAssociateStoresConfirmationPopup}
  toggle={() => setOpenAssociateStoresConfirmationPopup(false)}
  size="md"
  className='curve-popup'
>
{/* <p style={{ fontSize: '15px' }}>
  All Stores & Users from <b>{priorityAccounts.join(', ')}</b> will be transferred to <b>{props.AccountDetailsName}</b>. Please confirm.
</p> */}
<p style={{ fontSize: '15px' }}>
  All Stores & Users from <b>
    {
      priorityAccounts.length === 1
        ? priorityAccounts[0]
        : priorityAccounts.length === 2
        ? `${priorityAccounts[0]} and ${priorityAccounts[1]}`
        : `${priorityAccounts.slice(0, -1).join(', ')}, and ${priorityAccounts[priorityAccounts.length - 1]}`
    }
  </b> will be transferred to <b>{props.AccountDetailsName}</b>. Please confirm.
</p>

    <div className="text-right mt-4">
      <Button
        style={{ width: 55 }}
        className="btn-background-color"
        onClick={handleConfirmAssociation}
      >
        Yes
      </Button>

      <Button
        className="ml-3"
        onClick={() => setOpenAssociateStoresConfirmationPopup(false)}
      >
        No
      </Button>
    </div>
 
</CustomModal>

    </>
  )
}
const mapStateToProps = (state) => {
    return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
      error: state.loggedUser.error,
      adProfiles: state.accountOverview.landing.adProfiles,
    };
  };

export default connect(mapStateToProps)(AssociateStoresToAccountDetails);
